/**
 * Make URL more comfortable for end-users. **This function does not return valid URL**.
 * It removes the protocol, search parameters, and hash.
 */
export function prettifyUrl(url: string | URL): string {
	url = new URL(url);
	return url.host + (url.pathname === "/" ? "" : url.pathname);
}
